<div class="card_content">
    <div class="d-flex mt-4" style="height: 77vh;">
        <div class="filter-container" style="overflow-y: scroll;">
            <div class="scrollable-content px-1">
                <div style="margin-bottom: 6rem;">
                    <h5 class="pt-2 mr-2" style="text-align: center;">Features</h5>
                    <hr>
                    <!-- card Color -->
                    <!-- <div class="d-flex mt-2" (click)="isCardColorDropdownVisible = !isCardColorDropdownVisible"
                        style="cursor: pointer; ">
                        <h5 style="font-weight: normal; font-size: 18px;">Card Color</h5>
                        <ng-container *ngIf="!isCardColorDropdownVisible">
                            <app-icon name="arrow-rounded-down-12x7" class="d-flex" style="margin-left: auto;"
                                class="mr-2" size="12x7"></app-icon>
                        </ng-container>
                        <ng-container *ngIf="isCardColorDropdownVisible">
                            <app-icon name="arrow-rounded-up-13x8" class="d-flex" style="margin-left: auto;"
                                class="mr-2" size="13x8"></app-icon>
                        </ng-container>
                    </div> -->
                    <div *ngIf="isCardColorDropdownVisible" class="mt-2 ml-1">
                        <div class="row pl-3">
                            <div class="col-6 px-0">
                                <input type="radio" name="colorMode" [(ngModel)]="colorMode" value="single"
                                    (change)="updateBackground()" style="transform:scale(1) !important; " /><label
                                    style="font-size: 12px;" class="ml-1"> Single Color
                                </label>
                            </div>
                            <div class="col-6 px-0">

                                <input type="radio" name="colorMode" [(ngModel)]="colorMode" value="gradient"
                                    (change)="updateBackground()" style="transform:scale(1) !important;" /><label
                                    style="font-size: 12px;" class="ml-1"> Gradient
                                </label>
                            </div>
                        </div>
                        <ng-container *ngIf="colorMode!='single'">
                            <label class="mr-1">Color : </label>
                            <input [(colorPicker)]="colors.cardBgColor1" [cpAlphaChannel]="'always'"
                                [style.background]="colors.cardBgColor1" (colorPickerChange)="updateBackground()"
                                [cpWidth]="'200px'" [cpHeight]="'270px'" [cpPosition]="'fixed'" class="mr-5"
                                style="width: 12px; height:12px;  cursor:pointer;">

                            <label class="mr-1 ml-2">Color 2 : </label>
                            <input [(colorPicker)]="colors.cardBgColor2" [cpAlphaChannel]="'always'"
                                [style.background]="colors.cardBgColor2" (colorPickerChange)="updateBackground()"
                                class="mr-2" style="width: 12px; height:12px;  cursor:pointer;" [cpWidth]="'200px'"
                                [cpHeight]="'270px'" [cpPosition]="'fixed'">
                        </ng-container>
                        <div class="px-0" *ngIf="colorMode=='single'">
                            <label class="mr-3 pr-4">Color : </label>
                            <input [(colorPicker)]="colors.cardBgColor1" [cpAlphaChannel]="'always'"
                                [style.background]="colors.cardBgColor1" (colorPickerChange)="updateBackground()"
                                class="mr-2 ml-2" style="width: 12px; height:12px;  cursor:pointer;">
                            <input [(ngModel)]="colors.cardBgColor1" style="width: 37%; height:20px;">
                        </div>

                        <div class="row mt-2 pl-3" *ngIf="colorMode!='single'">

                            <div class="col-xl-6 col-md-12 px-0" *ngIf="colorMode!='single'">

                                <input [(ngModel)]="colors.cardBgColor1" style="width: 80%; height:20px;">

                                <input type="range" min="0" max="100" [(ngModel)]="colors.cardIntensity"
                                    *ngIf="colorMode!='single'" (input)="updateBackground()" style="width: 80%;"
                                    class="mt-2" />
                            </div>
                            <div class="col-xl-6 col-md-12 px-0" *ngIf="colorMode!='single'">

                                <input [(ngModel)]="colors.cardBgColor2" style="width: 80%; height:20px;">

                                <input type="range" min="0" max="100" [(ngModel)]="colors.cardIntensity1"
                                    (input)="updateBackground()" style="width: 80%;" class="mt-2" /><br>
                            </div>
                        </div>
                        <div class="mt-1" *ngIf="colorMode!='single'">
                            <label class="mr-1">Angle : </label>
                            <input type="number" min="0" max="360" [(ngModel)]="colors.cardAngle"
                                (input)="updateBackground()" style="width: 70%; height: 20px;" /><br>
                        </div>
                        <div class="mt-2">
                            <label class="mr-3">Price Color : </label>
                            <input [(colorPicker)]="colors.cardPriceBgColor" [cpAlphaChannel]="'always'"
                                [style.background]="colors.cardPriceBgColor" class="mr-2" [cpWidth]="'200px'"
                                [cpHeight]="'270px'" [cpPosition]="'top'"
                                style="width: 12px; height:12px;  cursor:pointer;">
                            <input [(ngModel)]="colors.cardPriceBgColor" style="width: 40%; height:20px;">
                        </div>
                        <div class="mt-2">
                            <label class="mr-2">Speed Color : </label>
                            <input [(colorPicker)]="colors.cardSpeedBgColor" [cpAlphaChannel]="'always'"
                                [style.background]="colors.cardSpeedBgColor" class="mr-2" [cpWidth]="'200px'"
                                [cpHeight]="'270px'" [cpPosition]="'top'"
                                style="width: 12px; height:12px;  cursor:pointer;">
                            <input [(ngModel)]="colors.cardSpeedBgColor" style="width: 40%; height:20px;">
                        </div>
                        <div class="mt-2">
                            <label class="mr-2">Button Color : </label>
                            <input [(colorPicker)]="colors.cardButtonBgColor" [cpAlphaChannel]="'always'"
                                [style.background]="colors.cardButtonBgColor" class="mr-2" [cpWidth]="'200px'"
                                [cpHeight]="'270px'" [cpPosition]="'top'"
                                style="width: 12px; height:12px;  cursor:pointer;">
                            <input [(ngModel)]="colors.cardButtonBgColor" style="width: 40%; height:20px;">
                        </div>
                        <div class="offer-banner">
                            <span class="line"></span>
                            <span class="text" style="font-size:11px !important; font-weight: normal !important;">Promo
                                Head Color</span>
                            <span class="line"></span>
                        </div>



                        <div class="row pl-3 mt-2">
                            <div class="col-6 px-0">
                                <input type="radio" name="promocolormode" [(ngModel)]="promocolormode" value="single"
                                    (change)="updatepromobackground" style="transform:scale(1) !important; " /><label
                                    style="font-size: 12px;" class="ml-1"> Single Color
                                </label>
                            </div>
                            <div class="col-6 px-0">
                                <input type="radio" name="promocolormode" [(ngModel)]="promocolormode" value="gradient"
                                    (change)="updatepromobackground" style="transform:scale(1) !important;" /><label
                                    style="font-size: 12px;" class="ml-1"> Gradient
                                </label>
                            </div>
                        </div>
                        <ng-container *ngIf="promocolormode!='single'">
                            <label class="mr-1">Color : </label>
                            <input [(colorPicker)]="colors.promoHeadBgColor1" [cpAlphaChannel]="'always'"
                                [style.background]="colors.promoHeadBgColor1"
                                (colorPickerChange)="updatepromobackground" [cpWidth]="'200px'" [cpHeight]="'270px'"
                                [cpPosition]="'fixed'" class="mr-5" style="width: 12px; height:12px;  cursor:pointer;">

                            <label class="mr-1 ml-2">Color 2 : </label>
                            <input [(colorPicker)]="colors.promoHeadBgColor2" [cpAlphaChannel]="'always'"
                                [style.background]="colors.promoHeadBgColor2"
                                (colorPickerChange)="updatepromobackground" class="mr-2"
                                style="width: 12px; height:12px;  cursor:pointer;" [cpWidth]="'200px'"
                                [cpHeight]="'270px'" [cpPosition]="'fixed'">
                        </ng-container>
                        <div class="px-0" *ngIf="promocolormode=='single'">
                            <label class="mr-3 pr-4">Color : </label>
                            <input [(colorPicker)]="colors.promoHeadBgColor1" [cpAlphaChannel]="'always'"
                                [style.background]="colors.promoHeadBgColor1"
                                (colorPickerChange)="updatepromobackground" class="mr-2 ml-2"
                                style="width: 12px; height:12px;  cursor:pointer;">
                            <input [(ngModel)]="colors.promoHeadBgColor1" style="width: 37%; height:20px;">
                        </div>

                        <div class="row mt-2 pl-3" *ngIf="promocolormode!='single'">

                            <div class="col-xl-6 col-md-12 px-0">

                                <input [(ngModel)]="colors.promoHeadBgColor1" style="width: 80%; height:20px;">

                                <input type="range" min="0" max="100" [(ngModel)]="colors.promoHeadIntensity"
                                    (input)="updatepromobackground" style="width: 80%;" class="mt-2" />
                            </div>
                            <div class="col-xl-6 col-md-12 px-0">

                                <input [(ngModel)]="colors.promoHeadBgColor2" style="width: 80%; height:20px;">

                                <input type="range" min="0" max="100" [(ngModel)]="colors.promoHeadIntensity1"
                                    (input)="updatepromobackground" style="width: 80%;" class="mt-2" /><br>
                            </div>
                        </div>
                        <div class="mt-1" *ngIf="promocolormode!='single'">
                            <label class="mr-1">Angle : </label>
                            <input type="number" min="0" max="360" [(ngModel)]="colors.promoHeadAngle"
                                (input)="updatepromobackground" style="width: 70%; height: 20px;" /><br>
                        </div>
                    </div>

                    <!-- <hr class="mt-2"> -->
                    <!-- Text Color -->
                    <!-- <div class="d-flex" (click)="istextColorDropdownVisible = !istextColorDropdownVisible"
                        style="cursor: pointer;">
                        <h5 style="font-weight: normal; font-size: 18px;">Text Color</h5>
                        <ng-container *ngIf="!istextColorDropdownVisible">
                            <app-icon name="arrow-rounded-down-12x7" class="d-flex" style="margin-left: auto;"
                                class="mr-2" size="12x7"></app-icon>
                        </ng-container>
                        <ng-container *ngIf="istextColorDropdownVisible">
                            <app-icon name="arrow-rounded-up-13x8" class="d-flex" style="margin-left: auto;"
                                class="mr-2" size="13x8"></app-icon>
                        </ng-container>
                    </div> -->
                    <div *ngIf="istextColorDropdownVisible" class="mt-2 ml-1">
                        <div class="mt-1">
                            <label class="mr-2">Promo Color : </label>
                            <input [(colorPicker)]="colors.promoTextColor" [cpAlphaChannel]="'always'"
                                (colorPickerChange)="updatepromotext" [style.background]="colors.promoTextColor"
                                class="mr-2" [cpWidth]="'200px'" [cpHeight]="'270px'" [cpPosition]="'top'"
                                style="width: 12px; height:12px;  cursor:pointer;">
                            <input [(ngModel)]="colors.promoTextColor" style="width: 40%; height:20px;">
                        </div>
                        <div class="mt-2">
                            <label class="mr-3">Price Color : </label>
                            <input [(colorPicker)]="colors.textPriceColor" [cpAlphaChannel]="'always'"
                                [style.background]="colors.textPriceColor" class="mr-2" [cpWidth]="'200px'"
                                [cpHeight]="'270px'" [cpPosition]="'top'"
                                style="width: 12px; height:12px;  cursor:pointer;">
                            <input [(ngModel)]="colors.textPriceColor" style="width: 40%; height:20px;">
                        </div>
                        <div class="mt-2" *ngIf="slashcolorshow">
                            <label class="mr-3">prev Price : </label>
                            <input [(colorPicker)]="colors.strikeOutColor" [cpAlphaChannel]="'always'"
                                [style.background]="colors.strikeOutColor" class="mr-2 ml-1" [cpWidth]="'200px'"
                                [cpHeight]="'270px'" [cpPosition]="'top'"
                                style="width: 12px; height:12px;  cursor:pointer;">
                            <input [(ngModel)]="colors.strikeOutColor" style="width: 40%; height:20px;">
                        </div>
                        <div class="mt-2">
                            <label class="mr-3 pr-1">SP Color : </label>
                            <input [(colorPicker)]="colors.textSpColor" [cpAlphaChannel]="'always'"
                                [style.background]="colors.textSpColor" class="mr-2 ml-2" [cpWidth]="'200px'"
                                [cpHeight]="'270px'" [cpPosition]="'top'"
                                style="width: 12px; height:12px;  cursor:pointer;">
                            <input [(ngModel)]="colors.textSpColor" style="width: 40%; height:20px;">
                        </div>
                        <div class="mt-2">
                            <label class="mr-2">Speed Color : </label>
                            <input [(colorPicker)]="colors.textSpeedColor" [cpAlphaChannel]="'always'"
                                [style.background]="colors.textSpeedColor" class="mr-2" [cpDialogDisplay]="'popup'"
                                [cpWidth]="'200px'" [cpHeight]="'270px'" [cpPosition]="'top'"
                                style="width: 12px; height:12px;  cursor:pointer;">
                            <input [(ngModel)]="colors.textSpeedColor" style="width: 40%; height:20px;">
                        </div>
                        <div class="mt-2">
                            <label class="mr-4">Buy Color : </label>
                            <input [(colorPicker)]="colors.buttonColor" [style.background]="colors.buttonColor"
                                class="mr-2" style="width: 12px; height:12px;  cursor:pointer;" [cpWidth]="'200px'"
                                [cpHeight]="'270px'" [cpPosition]="'top'">
                            <input [(ngModel)]="colors.buttonColor" style="width: 40%; height:20px;">
                        </div>
                    </div>
                    <!-- <hr class="mt-2"> -->
                    <!-- Banner & T&C -->
                    <div class="d-flex" (click)="isBannerDropdownVisible = !isBannerDropdownVisible"
                        style="cursor: pointer;">
                        <h5 style="font-weight: normal; font-size: 18px;">Banner & T&C</h5>
                        <ng-container *ngIf="!isBannerDropdownVisible">
                            <app-icon name="arrow-rounded-down-12x7" class="d-flex" style="margin-left: auto;"
                                class="mr-2" size="12x7"></app-icon>
                        </ng-container>
                        <ng-container *ngIf="isBannerDropdownVisible">
                            <app-icon name="arrow-rounded-up-13x8" class="d-flex" style="margin-left: auto;"
                                class="mr-2" size="13x8"></app-icon>
                        </ng-container>
                    </div>
                    <div *ngIf="isBannerDropdownVisible" class="mt-3 ml-3">
                        <!-- <input type="checkbox" [(ngModel)]="showpromo" /> Promotion Name<br> -->
                        <div class="d-flex">
                            <p class="mr-3 mt-1">Banner</p>
                            <button (click)="onImageUpload()" style="padding: 1px 8px 1px 8px;" class="btn-primary mr-3"
                                *ngIf="!imageUrl && !promdetails.bannerName">
                                <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg"
                                    style="width: 20px; " />
                            </button>
                            <button (click)="onImageUpload()" style="padding: 1px 8px 1px 8px;" class="btn-primary mr-3"
                                *ngIf="imageUrl || promdetails.bannerName">
                                <img src="../../../../assets/Home-Connect/icons/delete.svg"
                                    style="filter: invert(1);width: 20px;" />
                            </button>
                            <button (click)="showbanner()" style="padding: 1px 8px 1px 8px;"
                                *ngIf="imageUrl || promdetails.bannerName" class="btn-primary"> <i class="fa fa-eye"
                                    style="font-size: 18px; color: white;  "></i>
                            </button>
                        </div>
                        <div class="d-flex">
                            <p class="mr-2 pr-1 mt-1">T&C</p>
                            <button style="padding: 1px 8px 1px 8px;" class="btn-primary ml-4 mr-3"
                                (click)="showEditor()"><i class="fa fa-pen" style="font-size: 18px; color: white;"></i>

                            </button>
                            <button style="padding: 1px 8px 1px 8px;" *ngIf="promoContent" class="btn-primary"
                                (click)="toggleDrawer()"> <i class="fa fa-eye"
                                    style="font-size: 18px; color: white;  "></i>
                            </button>
                        </div>
                    </div>
                    <hr class="mt-2">
                    <div class="d-flex" (click)="is24eastDropdownVisible = !is24eastDropdownVisible"
                        style="cursor: pointer;">
                        <h5 style="font-weight: normal; font-size: 18px;">28 East</h5>
                        <ng-container *ngIf="!is24eastDropdownVisible">
                            <app-icon name="arrow-rounded-down-12x7" class="d-flex" style="margin-left: auto;"
                                class="mr-2" size="12x7"></app-icon>
                        </ng-container>
                        <ng-container *ngIf="is24eastDropdownVisible">
                            <app-icon name="arrow-rounded-up-13x8" class="d-flex" style="margin-left: auto;"
                                class="mr-2" size="13x8"></app-icon>
                        </ng-container>
                    </div>
                    <div *ngIf="is24eastDropdownVisible" class="mt-2 ml-1">
                        <div class="col-sm-12 col-md-12 mt-2 test pl-0">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>TAG</mat-label>
                                <input matInput maxlength="25" style="font-size:14px !important"
                                    [(ngModel)]="twentyEightEastTag" placeholder="Enter 28 East Tag number"
                                    class="col-10 no-spinner" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>

                    <hr class="mt-2">

                </div>
            </div>
        </div>
        <div class="fixed-container">

            <div class="scrollable-content">
                <div class="row">
                    <div class="packages px-0 col-xl-12">
                        <div class="row packages-container mx-3" style="text-wrap:nowrap;margin-bottom: 8rem;">
                            <ng-container *ngFor="let provider of serviceProviders">
                                <div *ngIf="selectedProductsByProvider[provider]?.length" class="col-12">
                                    <!-- Provider Heading -->
                                    <!-- <h4 class="provider-heading">{{ provider }}</h4> -->
                                    <div class="offer-banner">
                                        <span class="line"></span>
                                        <span class="text">{{ provider }}</span>
                                        <span class="line"></span>
                                    </div>
                                    <div class="row d-flex justify-content-center">

                                        <div *ngFor="let groupedProduct of selectedProductsByProvider[provider]"
                                            class="col-xl-3 px-2 mt-4 ">

                                            <div class="package" [ngClass]="showpromo ? '' : 'promohead'"
                                                [style.background]="updateBackground">
                                                <div class="row" *ngIf="showpromo">
                                                    <div class="col-2"></div>
                                                    <div class="col-8 super24-label"
                                                        [style.background]="updatepromobackground">
                                                        <mat-form-field class="title-input">
                                                            <input matInput [(ngModel)]="promdetails.promoCode"
                                                                [style.color]="this.colors.promoTextColor"
                                                                class="promo_input"
                                                                [style.text-shadow]="updatepromotext" readonly>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-2"></div>
                                                </div>

                                                <div class="package-card" [style.background]="colors.cardPriceBgColor"
                                                    [style.color]="colors.textPriceColor"
                                                    *ngIf="!groupedProduct.showcost"
                                                    [style.marginTop]="showpromo?'13px !important':'40px !important'">
                                                    <i class="fa fa-pen" (click)="editprice(groupedProduct,true)"
                                                        style="cursor: pointer; font-size: 14px; position: absolute; margin-left:4rem; margin-top:2.5rem"></i>
                                                    <h5><span style="font-size: 16px;"
                                                            [style.color]="colors.textPriceColor">R</span>
                                                        {{groupedProduct.totalAmount}}</h5>
                                                    <h6 class="per-month">Per Month</h6>
                                                </div>
                                                <div class="package-card price-box"
                                                    [style.background]="colors.cardPriceBgColor"
                                                    *ngIf="groupedProduct.showcost"
                                                    [style.color]="colors.textPriceColor"
                                                    [style.marginTop]="showpromo?'13px !important':'40px !important'">

                                                    <div class="price_input_box">
                                                        <i class="fa fa-close" (click)="editprice(groupedProduct,false)"
                                                            style="cursor: pointer; font-size: 16px; position: absolute; margin-left:9rem;margin-top: 2.5rem;"></i>
                                                        <mat-form-field class="price-input mr-1"
                                                            style="margin-top: -30px !important;padding-right:10px ;">
                                                            <input matInput [(ngModel)]="groupedProduct.promotionCost"
                                                                (keydown)="restrictNegative($event)"  [disabled]="view == 2"
                                                                [style.color]="colors.textPriceColor" type="number"
                                                                style="font-size: 20px !important;text-align: right;">
                                                        </mat-form-field>
                                                        <span style="margin-top: -8px;">/</span>
                                                        <span class="price-strike-input"
                                                            [style.color]="colors.strikeOutColor">
                                                            {{groupedProduct.totalAmount}}
                                                        </span>
                                                    </div>
                                                    <p class="per-month-price">Per Month</p>
                                                </div>
                                                <h6 class="head-openserve" [style.color]="colors.textSpColor"
                                                    style="margin: 0;">{{groupedProduct.provider }}</h6>

                                                <div class="row mbps mx-2" style="flex-wrap:nowrap !important"
                                                    [style.background]="colors.cardSpeedBgColor"
                                                    [style.color]="colors.textSpeedColor">
                                                    <div
                                                        class="col-5 content-left d-flex justify-content-center align-items-center flex-column">
                                                        <mat-form-field class="text-center font-weight-bold"
                                                            style="margin-top: -12px !important;">
                                                            <input matInput type="number"
                                                                [(ngModel)]="groupedProduct.downloadSpeed"
                                                                style="font-size: 17px !important;">
                                                        </mat-form-field>
                                                        <div style="font-size: 10px;" class="mb-0">Mbps</div>
                                                        <!-- <img class="down-up"
                                                    src="../../../../assets/images/providersImg/download-1.svg"
                                                    height="20px" > -->
                                                        <i class="fa fa-arrow-down my-1" style="font-size: 17px;"></i>
                                                        <div style="font-size: 10px;">Download</div>
                                                        <div style="font-size: 10px;">Speed</div>
                                                    </div>
                                                    <div class="col-2 line"></div>
                                                    <div
                                                        class="col-5 content-left d-flex justify-content-center align-items-center flex-column">
                                                        <mat-form-field class="text-center font-weight-bold"
                                                            style="margin-top: -12px !important;">
                                                            <input matInput type="number"
                                                                [(ngModel)]="groupedProduct.uploadSpeed"
                                                                style="font-size: 17px !important;">
                                                        </mat-form-field>
                                                        <div style="font-size: 10px;" class="mb-0">Mbps</div>
                                                        <!-- <img class="down-up"
                                                    src="../../../../assets/images/providersImg/upload-1.svg"
                                                    height="20px"> -->
                                                        <i class="fa fa-arrow-up my-1" style="font-size: 17px;"></i>

                                                        <div style="font-size: 10px;">Upload</div>
                                                        <div style="font-size: 10px;">Speed</div>
                                                    </div>
                                                </div>

                                                <button class="buy-button" [style.color]="colors.buttonColor"
                                                    [style.marginTop]="showpromo?'14px !important':'22px !important'"
                                                    [style.background]="colors.cardButtonBgColor">BUY</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mx-5">
                                        <div class="col-sm-12 col-md-6 mt-4">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Activation Fee</mat-label>
                                                <input matInput type="number" maxlength="25"
                                                    style="font-size:16px !important"
                                                    [ngModel]="serviceProviderFees[provider]?.activationFee"
                                                    (ngModelChange)="updateFee(provider, 'activationFee', $event)"
                                                    (keydown)="restrictNegative($event)"
                                                    placeholder="Enter Activation Fee" class="col-10 no-spinner"
                                                    autocomplete="off" required [disabled]="view == 2">
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-12 col-md-6 mt-4">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Installation Fee</mat-label>
                                                <input matInput type="number" maxlength="25"
                                                    style="font-size:16px !important"
                                                    [ngModel]="serviceProviderFees[provider]?.installationFee"
                                                    (ngModelChange)="updateFee(provider, 'installationFee', $event)"
                                                    (keydown)="restrictNegative($event)"
                                                    placeholder="Enter Installation Fee" class="col-10 no-spinner"
                                                    autocomplete="off" required [disabled]="view == 2">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-container p-2">
            <div style="height: 90%;">
                <div class="scrollable-content" style="overflow-y: scroll;">
                    <div style="margin-bottom: 6rem;">
                        <!-- Service Providers Button Selection -->
                        <h5 style="text-align: center;margin-bottom: 20px;">Service Providers</h5>

                        <div>
                            <div *ngFor="let provider of serviceProviders">
                                <ng-container *ngIf="provider!='All'" class="sp">
                                    <h6 class="mb-1" style="font-size: 14px;"> {{ provider }}:</h6>

                                    <mat-form-field appearance="outline" class="full-width sp">
                                        <mat-label>Select Products</mat-label>
                                        <mat-select multiple [(value)]="selectedProductsByProvider[provider]" [disabled]="view === 2"
                                            (focus)="setPreviousSelection(provider)"
                                            (blur)="setPreviousSelection(provider)"
                                            (selectionChange)="onProductSelectionChange($event, provider)">
                                            <mat-option *ngFor="let product of productsMap[provider]" [value]="product">
                                                {{ product.aliasName }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>
                                <hr>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row d-flex justify-content-center">
                <button class="btn-primary mr-3" (click)="back()">
                    Back
                </button>
                <button class="btn-secondary " (click)="save()" *ngIf="view!=2">
                    Save
                </button>
            </div>
        </div>
        <app-drawer [isOpen]="true" [content]="promoContent"></app-drawer>
    </div>
</div>